module.exports = __webpack_public_path__ + "static/media/Places.a71e0199.jpg";